import { Component } from '@angular/core'
import { Release, RELEASES } from '../../../../changelog'

@Component({
    selector: 'ppw-whats-new',
    templateUrl: './whats-new.component.html',
    styleUrls: ['./whats-new.component.scss']
})
export class WhatsNewComponent {
    releases: Array<Release> = RELEASES
}
